import { Mail } from "lucide-react";
import { EmailEdit } from "./EmailEdit";
import { EmailList } from "./EmailList";

export default {
  list: EmailList,
  edit: EmailEdit,
  icon: Mail,
};
